export default __webpack_public_path__ + "static/media/honeyJars.fe1421f5.jpg";